import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { publishReplay, refCount } from 'rxjs/operators';
import { Supplier, SupplierBrand, SupplierCertification } from '../../models/supplier.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SupplierService {

  listSuppliers: Supplier[];
  editing: Supplier;
  list_supplier_brands: SupplierBrand[];
  editing_supplier_brand: SupplierBrand;
  list_supplier_certification: SupplierCertification[];
  editing_supplier_certification: SupplierCertification;

  public baseUrl = 'koncentro-common';

  private cachedFields: Observable<any>;
  private cachedFieldsBrand: Observable<any>;
  private cachedFieldsCertification: Observable<any>;

  constructor(
    private h: HttpClientService,
    private datePipe: DatePipe) {
  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<any> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged('/koncentro-common/suppliers' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  getList() {
    return this.h.get('/koncentro-common/suppliers')
      .map(res => {
        return this.listSuppliers = res;
      })
  }

  get(id: number) {

    return this.h.get(`/${this.baseUrl}/suppliers/${id}`)
      .map(res => {
        this.editing = res;
      })
  }

  getSupplierBrands(supplier_id: number) {
    return this.h.get(`/${this.baseUrl}/suppliers/${supplier_id}/brands`);
  }

  getSupplierCertifications(supplier_id: number) {
    return this.h.get(`/${this.baseUrl}/suppliers/${supplier_id}/certifications`);
  }

  post(supplier: Supplier) {

    return this.h.post(`/${this.baseUrl}/suppliers`, supplier)
      .map(data => {

      })
  }

  postSupplierBrand(id: number, supplier_brand: SupplierBrand) {

    return this.h.post(`/${this.baseUrl}/suppliers/${id}/brands`, supplier_brand)
      .map(data => {

      })
  }

  postSupplierCertification(id: number, supplier_certification: SupplierCertification) {

    return this.h.post(`/${this.baseUrl}/suppliers/${id}/certifications`, supplier_certification)
      .map(data => {

      })
  }

  put(id: number, supplier: Supplier) {

    return this.h.put(`/${this.baseUrl}/suppliers/` + id , supplier)
      .map(data => {

      })
  }


  delete (id: number) {
    return this.h.delete(`/${this.baseUrl}/suppliers/` + id)
      .map(res => {

      })
  }

  recover (id: number) {
    return this.h.put(`/${this.baseUrl}/suppliers/recover/` + id, null);
  }

  deleteSupplierBrand (id: number, supplier_brand_id: number) {
    return this.h.delete(`/${this.baseUrl}/suppliers/${id}/brands/${supplier_brand_id}`)
      .map(res => {

      })
  }

  deleteSupplierCertification (id: number, supplier_certification_id: number) {
    return this.h.delete(`/${this.baseUrl}/suppliers/${id}/certifications/${supplier_certification_id}`)
      .map(res => {

      })
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/SupplierDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getFieldsBrand() {
    if (!this.cachedFieldsBrand) {
      this.cachedFieldsBrand = this.h.get('/koncentro-common/schema/SupplierBrandDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFieldsBrand;
  }

  getFieldsCertification() {
    if (!this.cachedFieldsCertification) {
      this.cachedFieldsCertification = this.h.get('/koncentro-common/schema/SupplierCertificationDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFieldsCertification;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/supplier/supplier.service.ts